import React, { useContext, useState, useEffect } from "react";
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import PrivateRoute from './PrivateRoute.jsx'
import Home from './layout/Home/Home.jsx'
import Inicio from './layout/Home/Inicio.jsx'
import Login from './layout/Login/Login.jsx'
import ListadoUsuarios from './layout/Login/ListadoUsuarios.jsx'
import ListadoUsuariosAdmin from './layout/Login/ListadoUsuariosAdmin.jsx'
import Logout from './layout/Login/Logout.jsx'
import AuthContextProvider from "./contexts/AuthContext.jsx";
import { ChatContextProvider } from "./contexts/ChatContext.jsx";
import ChatWidget from "./ChatWidget.jsx";

// {/* Catalogos */}
import BotonesCatalogos from "./views/Catalogos/BotonesCatalogos.jsx"
import ListadoAreas from './views/Catalogos/Areas/ListadoAreas.jsx'
import ListadoPaqueterias from './views/Catalogos/Paqueterias/ListadoPaqueterias.jsx'
import ListadoProveedores from './views/Catalogos/Proveedores/ListadoProveedores.jsx'
import ProveedoresCreate from './views/Catalogos/Proveedores/ProveedoresCreate.jsx'
import ListadoCiclos from './views/Catalogos/Ciclos/ListadoCiclos.jsx'
import ListadoPeriodosAdmin from './views/Catalogos/PeriodosAdmin/ListadoPeriodosAdmin.jsx'
import PeriodosAdminCreate from './views/Catalogos/PeriodosAdmin/PeriodosAdminCreate.jsx'
import ListadoDepartamentos from './views/Catalogos/Departamentos/ListadoDepartamentos.jsx'
import ListadoGrupos from './views/Catalogos/Grupos/ListadoGrupos.jsx'

// {/* Articulos */}
import BotonesArticulos from "./views/Articulos/BotonesArticulos.jsx"
import ListadoLineas from './views/Articulos/Lineas/ListadoLineas.jsx'
import ListadoColores from './views/Articulos/Colores/ListadoColores.jsx'
import ListadoTallas from "./views/Articulos/Tallas/ListadoTallas.jsx";
import ListadoMarcas from './views/Articulos/Marcas/ListadoMarcas.jsx'
import ListadoFamilias from './views/Articulos/Familias/ListadoFamilias.jsx'
import ListadoColecciones from './views/Articulos/Colecciones/ListadoColecciones.jsx'
import ListadoArticulos from './views/Articulos/Articulos/ListadoArticulos.jsx'
import ListadoArticulosFoto from './views/Articulos/Articulos/ListadoArticulosFoto.jsx'
import ArticulosCreate from './views/Articulos/Articulos/ArticulosCreate.jsx'
import ArticulosBulkCreate from './views/Articulos/Articulos/ArticulosBulkCreate.jsx'
import GeneradorEtiquetas from "./views/Articulos/Articulos/GeneradorEtiquetas.jsx";

// {/* Inventarios */}
import BotonesInventarios from "./views/Inventarios/BotonesInventarios.jsx"
import ListadoInventarios from './views/Inventarios/Inventarios/ListadoInventarios.jsx'
import ListadoDisponible from "./views/Inventarios/Inventarios/ListadoDisponible.jsx";
import ListadoKardex from "./views/Inventarios/Inventarios/ListadoKardex.jsx";
import ListadoTracking from "./views/Inventarios/Inventarios/ListadoTracking.jsx";
import InventariosSeparados from "./views/Inventarios/Inventarios/InventariosSeparados.jsx";
import ListadoDisponibleVendedor from "./views/Inventarios/Inventarios/ListadoDisponibleVendedor.jsx";
import ListadoInventarioPendRecibir from "./views/Inventarios/Inventarios/ListadoInventarioPendRecibir.jsx";
import ListadoAjustesInventario from "./views/Inventarios/Ajustes/ListadoAjustesInventario.jsx"
import AjustesInventarioCreate from "./views/Inventarios/Ajustes/AjustesInventarioCreate.jsx"
import BotonesTraspasos from "./views/Inventarios/BotonesTraspasos.jsx"
import CuadrarInventario from "./views/Inventarios/Inventarios/CuadrarInventario.jsx";

// Tiendas
import BotonesTiendas from "./views/Tiendas/BotonesTiendas.jsx"
import ListadoInventariosTiendas from './views/Tiendas/ListadoInventariosTiendas.jsx'
import ListadoVentasTiendas from './views/Tiendas/VentasTiendas/ListadoVentasTiendas.jsx'
import VentasTiendasCreate from './views/Tiendas/VentasTiendas/VentasTiendasCreate.jsx'
import ListadoApartadosTiendas from "./views/Tiendas/ApartadosTiendas/ListadoApartadosTiendas.jsx";
import ApartadosTiendasCreate from './views/Tiendas/ApartadosTiendas/ApartadosTiendasCreate.jsx'
import AbonosTiendasCreate from './views/Tiendas/AbonosTiendas/AbonosTiendasCreate.jsx'
import ListadoAbonosTiendas from './views/Tiendas/AbonosTiendas/ListadoAbonosTiendas.jsx'
import ListadoGastosTiendas from './views/Tiendas/GastosTiendas/ListadoGastosTiendas.jsx'
import GastosTiendasCreate from './views/Tiendas/GastosTiendas/GastosTiendasCreate.jsx'
import ListadoDinerosTiendas from "./views/Tiendas/DinerosTiendas/ListadoDinerosTiendas.jsx";
import DinerosTiendasCreate from "./views/Tiendas/DinerosTiendas/DinerosTiendasCreate.jsx";
import ListadoDevolucionesTiendas from './views/Tiendas/DevolucionesTiendas/ListadoDevolucionesTiendas.jsx'
import DevolucionesTiendasCreate from './views/Tiendas/DevolucionesTiendas/DevolucionesTiendasCreate.jsx'
import CorteTiendas from "./views/Tiendas/CorteTiendas/CorteTiendas.jsx";
import CorteTiendasK from "./views/Tiendas/CorteTiendas/CorteTiendasK.jsx";
import EntregarNota from "./views/Tiendas/VentasTiendas/EntregarNota.jsx";
import EstadoCuentaTiendas from "./views/Tiendas/EstadoCuentaTiendas/EstadoCuentaTiendas.jsx";
import EstadoCuentaTiendasAnalisis from "./views/Tiendas/EstadoCuentaTiendas/EstadoCuentaTiendasAnalisis.jsx";
import ListadoVentasTiendasPendientes from "./views/Tiendas/VentasTiendas/ListadoVentasTiendasPendientes.jsx";
import ListadoDevolucionesTiendasAdmin from "./views/Tiendas/DevolucionesTiendas/ListadoDevolucionesTiendasAdmin.jsx";
import ListadoClientesTiendas from "./views/Tiendas/ClientesTiendas/ListadoClientesTiendas.jsx";
import ClientesCreateTiendas from "./views/Tiendas/ClientesTiendas/ClientesCreateTiendas.jsx";
import FacturasTiendasCreate from "./views/Tiendas/VentasTiendas/FacturasTiendasCreate.jsx";
import Escaneos from "./views/Tiendas/EscaneosTiendas/EscaneosTiendas.jsx";
import ListadoEscaneos from "./views/Tiendas/EscaneosTiendas/ListadoEscaneos.jsx";

// Traspasos
import TraspasosSalidaCreate from './views/Inventarios/Traspasos/TraspasosSalidaCreate.jsx'
import ListadoTraspasosSalida from './views/Inventarios/Traspasos/ListadoTraspasosSalida.jsx'
import TraspasosEntradaCreate from './views/Inventarios/Traspasos/TraspasosEntradaCreate.jsx'
import ListadoTraspasosEntrada from './views/Inventarios/Traspasos/ListadoTraspasosEntrada.jsx'



// {/* Compras */}
import BotonesCompras from "./views/Compras/BotonesCompras.jsx"
import ListadoOrdenesCompra from './views/Compras/OrdenesCompra/ListadoOrdenesCompra.jsx'
import OrdenesCompraCreate from './views/Compras/OrdenesCompra/OrdenesCompraCreate.jsx'
import ListadoEmbarques from './views/Compras/Embarques/ListadoEmbarques.jsx'
import EmbarquesCreate from './views/Compras/Embarques/EmbarquesCreate.jsx'
import ListadoPendEmbarcar from "./views/Compras/Embarques/ListadoPendEmbarcar.jsx";
import ListadoCompras from "./views/Compras/Compras/ListadoCompras.jsx";
import ComprasCreate from "./views/Compras/Compras/ComprasCreate.jsx";
import ListadoPendRecibir from "./views/Compras/Compras/ListadoPendRecibir.jsx";
import ListadoConceptosGastosEmbarques from "./views/Compras/ConceptosGastosEmbarques/ListadoConceptosGastosEmbarques.jsx";
import ListadoControlCalidad from "./views/Compras/Compras/ListadoControlCalidad.jsx";

// {/* Ventas */}
import BotonesVentas from "./views/Ventas/BotonesVentas.jsx"
import ListadoPedidos from './views/Ventas/Pedidos/ListadoPedidos.jsx'
import VistaPedido from "./views/Ventas/Pedidos/VistaPedido.jsx";
import PedidosCreate from './views/Ventas/Pedidos/PedidosCreate.jsx'
import ListadoSurtidos from './views/Ventas/Surtidos/ListadoSurtidos.jsx'
import ListadoPendienteSurtir from './views/Ventas/Surtidos/ListadoPendienteSurtir.jsx'
import ListadoDevoluciones from './views/Ventas/Devoluciones/ListadoDevoluciones.jsx'
import DevolucionesCreate from './views/Ventas/Devoluciones/DevolucionesCreate.jsx'
import ListadoDepartamentosClientes from './views/Ventas/DepartamentosClientes/ListadoDepartamentosClientes.jsx'
import AnalisisArticulosPedidos from "./views/Ventas/Pedidos/AnalisisArticulosPedidos.jsx";
import ListoSurtir from "./views/Ventas/Pedidos/ListoSurtir.jsx";
import ListoSurtirCliente from "./views/Ventas/Pedidos/ListoSurtirCliente.jsx";
import ReporteVentasPorVendedor from "./views/Ventas/ReporteVentasPorVendedor.jsx";

// {/* Gastos */}
import BotonesGastos from "./views/ConfigAdmin/BotonesGastos.jsx"
import ListadoPresupuestos from './views/ConfigAdmin/Presupuestos/ListadoPresupuestos.jsx'
import PresupuestosCreate from './views/ConfigAdmin/Presupuestos/PresupuestosCreate.jsx'
import ListadoGastos from './views/ConfigAdmin/Gastos/ListadoGastos.jsx'
import GastosCreate from './views/ConfigAdmin/Gastos/GastosCreate.jsx'


import ListadoGastosGeneral from './views/ConfigAdmin/GastosGeneral/ListadoGastosGeneral.jsx'
import GastosGeneralCreate from './views/ConfigAdmin/GastosGeneral/GastosGeneralCreate.jsx'
import ListadoConceptosGastos from './views/ConfigAdmin/ConceptosGastos/ListadoConceptosGastos.jsx'
import ConceptosGastosCreate from './views/ConfigAdmin/ConceptosGastos/ConceptosGastosCreate.jsx'


//Nominas
import BotonesNominas from './views/Empleados/BotonesNominas.jsx'
import ListadoNominas from "./views/Empleados/Nominas/ListadoNominas.jsx"
import ListadoColaboradores from "./views/Empleados/Colaboradores/ListadoColaboradores.jsx"
import ListadoFaltasColaboradores from './views/Empleados/Faltas/ListadoFaltasColaboradores.jsx'
import FaltasColaboradoresCreate from './views/Empleados/Faltas/FaltasColaboradoresCreate.jsx'
import ListadoPuestos from "./views/Empleados/Puestos/ListadoPuestos.jsx"
import NominasCreate from "./views/Empleados/Nominas/NominasCreate.jsx"
import ColaboradoresCreate from "./views/Empleados/Colaboradores/ColaboradoresCreate.jsx"

// Clientes
import ListadoClientes from "./views/Clientes/Clientes/ListadoClientes.jsx"
import ClientesCreate from "./views/Clientes/Clientes/ClientesCreate.jsx"


//Reportes
import BotonesReportes from './views/Reportes/BotonesReportes.jsx'
import BotonesReportesV2 from './views/Reportes/BotonesReportesV2.jsx'
import GraficaVentasMensual from "./views/Reportes/GraficaVentasMensual.jsx";
import GraficaVentasMensualVendedor from "./views/Reportes/GraficaVentasMensualVendedor.jsx";
import GraficaVentasDepartamento from "./views/Reportes/GraficaVentasDepartamento.jsx";
import GraficaVentasGrupo from "./views/Reportes/GraficaVentasGrupo.jsx";
import GraficaVentasVendedor from "./views/Reportes/GraficaVentasVendedor.jsx";
import GraficaVentasEstado from "./views/Reportes/GraficaVentasEstado.jsx";
import ReporteUltimoPrecio from "./views/Reportes/ReporteUltimoPrecio.jsx";
import ReporteUltimoPrecioArticulo from "./views/Reportes/ReporteUltimoPrecioArticulo.jsx";
import GraficaVentasMensualCliente from "./views/Reportes/GraficaVentasMensualCliente.jsx";
import ValorInventario from './views/Reportes/ValorInventario.jsx'
import ListadoSellThru from "./views/Reportes/ListadoSellThru.jsx";
import CalificadoraClientes from "./views/Reportes/CalificadoraClientes.jsx";
import BotonesReportesVentas from "./views/Reportes/BotonesReportesVentas.jsx";
import BotonesReportesAdmin from "./views/Reportes/BotonesReportesAdmin.jsx";
import GraficaVentasMensualComparativa from "./views/Reportes/GraficaVentasMensualComparativa.jsx";
import GraficaVentasDesgloce from "./views/Reportes/GraficaVentasDesgloce.jsx";
import ReporteResumenAbonosTiendas from "./views/Reportes/ReporteResumenAbonosTiendas.jsx";
import ReporteResumenVentasTiendas from "./views/Reportes/ReporteResumenVentasTiendas.jsx";
import TablaVentasMensualComparativa from "./views/Reportes/TablaVentasMensualComparativa.jsx";
import TablaAbonosMensualComparativa from "./views/Reportes/TablaAbonosMensualComparativa.jsx";
import TablaAbonosMensualComparativaAlmacen from "./views/Reportes/TablaAbonosMensualComparativaAlmacen.jsx";
import TablaVentasMensualComparativaCliente from "./views/Reportes/TablaVentasMensualComparativaCliente.jsx";
import TablaVentasMensualComparativaVendedor from "./views/Reportes/TablaVentasMensualComparativaVendedor.jsx";
import TablaVentasArticulos from "./views/Reportes/TablaVentasArticulos.jsx";

// Fiscal
import BotonesFiscal from "./views/Fiscal/BotonesFiscal.jsx";
import ListadoFacturas from "./views/Fiscal/Facturacion/ListadoFacturas.jsx";
import FacturasCreate from "./views/Fiscal/Facturacion/FacturasCreate.jsx";
import ListadoComplementosPago from "./views/Fiscal/ComplementosPago/ListadoComplementosPago.jsx";
import ComplementosPagoCreate from "./views/Fiscal/ComplementosPago/ComplementosPagoCreate.jsx";
import NotasCreditoCreate from "./views/Fiscal/NotasCredito/NotasCreditoCreate.jsx";
import ListadoNotasCredito from "./views/Fiscal/NotasCredito/ListadoNotasCredito.jsx";
import DevolucionesFiscalCreate from "./views/Fiscal/DevolucionesFiscal/DevolucionesFiscalCreate.jsx";
import ListadoDevolucionesFiscal from "./views/Fiscal/DevolucionesFiscal/ListadoDevolucionesFiscal.jsx";
import RegistrarEmpresas from "./views/Fiscal/RegistrarEmpresa/RegistrarEmpresas.jsx";
import ListadoEmpresas from "./views/Fiscal/Empresas/ListadoEmpresas.jsx";
import EmpresasCreate from "./views/Fiscal/Empresas/EmpresasCreate.jsx";


// Dashboards
import BotonesDashboards from "./views/Reportes/BotonesDashboards.jsx";
import DashboardVentas from "./views/Reportes/DashboardVentas.jsx";
import DashboardInventarios from "./views/Reportes/DashboardInventarios.jsx";
import Balance from "./views/Reportes/Balance.jsx";

// Logs
import Logs from './views/Logs/ListadoLogs.jsx'
import AsistenteIAPage from './views/AsistenteIA/AsistenteIAPage.jsx'

// Monitoring
import Monitoring from "./views/Monitoring/Monitoring.jsx";

// Config
import Configuraciones from './views/Configuracion/Configuraciones.jsx'

// Admin
import BotonesAdmin from "./views/Admin/BotonesAdmin.jsx";
import ListadoBancos from "./views/Admin/Bancos/ListadoBancos.jsx";
import AnticiposCreate from './views/Admin/Anticipos/AnticiposCreate.jsx'
import ListadoAnticipos from './views/Admin/Anticipos/ListadoAnticipos.jsx'
import AbonosCreate from './views/Admin/Abonos/AbonosCreate.jsx'
import ListadoAbonos from './views/Admin/Abonos/ListadoAbonos.jsx'
import NotasCargoCreate from './views/Admin/NotasCargo/NotasCargoCreate.jsx'
import ListadoNotasCargo from './views/Admin/NotasCargo/ListadoNotasCargo.jsx'
import ListadoDevolucionesAdmin from './views/Admin/DevolucionesAdmin/ListadoDevolucionesAdmin.jsx'
import EstadoCuenta from "./views/Admin/EstadoCuenta/EstadoCuenta.jsx";
import ComisionesCreate from "./views/Admin/Comisiones/ComisionesCreate.jsx";
import ListadoComisiones from "./views/Admin/Comisiones/ListadoComisiones.jsx";
import EstadoCuentaColaboradores from "./views/Admin/Comisiones/EstadoCuentaColaboradores.jsx";
import ListadoVentas from "./views/Admin/Ventas/ListadoVentas.jsx";

// CXP
import BotonesCXP from "./views/CXP/BotonesCXP.jsx";
import EstadoCuentaCXP from "./views/CXP/EstadoCuentaCXP/EstadoCuentaCXP.jsx";
import ListadoComprasCXP from "./views/CXP/ComprasCXP/ListadoComprasCXP.jsx";
import AbonosProveedoresCreate from './views/CXP/AbonosProveedores/AbonosProveedoresCreate.jsx'
import ListadoAbonosProveedores from './views/CXP/AbonosProveedores/ListadoAbonosProveedores.jsx'

//Traspasos Dinero
import TraspasosDineroCreate from './views/Tiendas/TraspasosDinero/TraspasosDineroCreate.jsx'
import ListadoTraspasosDinero from './views/Tiendas/TraspasosDinero/ListadoTraspasosDinero.jsx'


//  Cadenas
import BotonesCadenas from "./views/Cadenas/BotonesCadenas.jsx"
import ListadoInsumos from "./views/Cadenas/Insumos/ListadoInsumos.jsx"
import InsumosCreate from "./views/Cadenas/Insumos/InsumosCreate.jsx";
import ListadoProveedoresMex from './views/Cadenas/ProveedoresMex/ListadoProveedoresMex.jsx'
import ProveedoresCreateMex from './views/Cadenas/ProveedoresMex/ProveedoresCreateMex.jsx'
import ListadoOrdenesCompraHab from './views/Cadenas/OrdenesCompraHab/ListadoOrdenesCompraHab.jsx'
import OrdenesCompraHabCreate from './views/Cadenas/OrdenesCompraHab/OrdenesCompraHabCreate.jsx'
import ListadoComprasHab from "./views/Cadenas/ComprasHab/ListadoComprasHab.jsx";
import ComprasHabCreate from "./views/Cadenas/ComprasHab/ComprasHabCreate.jsx";
import ListadoInventariosInsumos from "./views/Cadenas/Insumos/ListadoInventariosInsumos.jsx";
import ListadoCadenas from "./views/Cadenas/Cadenas/ListadoCadenas.jsx";
import ListadoPedidosCadenas from './views/Cadenas/Pedidos/ListadoPedidosCadenas.jsx'
import EstadoCuentaHab from "./views/Cadenas/EstadoCuentaHab/EstadoCuentaHab.jsx";
import AbonosProveedoresHabCreate from "./views/Cadenas/AbonosProveedoresHab/AbonosProveedoresHabCreate.jsx";
import ListadoAbonosProveedoresHab from "./views/Cadenas/AbonosProveedoresHab/ListadoAbonosProveedoresHab.jsx";


// Whastapp
import Whatsapp from "./views/WhatsApp/Whatsapp.jsx";
import ListadoClientesWhatsapp from "./views/VentasWhatsApp/ListadoClientesWhatsapp.jsx";
import ListadoPedidosWhatsapp from "./views/VentasWhatsApp/Pedidos/ListadoPedidosWhatsapp.jsx";

function RoutesComponent() {
    return (
        <AuthContextProvider>
            <ChatContextProvider>
            <BrowserRouter>
            <Routes>
                <Route path ="/" element={<Login />} />
                <Route path ="/Inicio" element={<Inicio />} />
                <Route path ="/Login" element={<Login />} />
                <Route path ="/Logout" element={<Logout />} />
                <Route path ="/MenuUsuarios" element={<ListadoUsuarios />} />
                <Route path ="/MenuUsuariosAdmin" element={<ListadoUsuariosAdmin />} />
                {/* Catalogos */}
                <Route path ="/MenuCatalogos" element={<BotonesCatalogos />} />
                <Route path ="/Areas" element={<ListadoAreas />} />
                <Route path ="/Paqueterias" element={<ListadoPaqueterias />} />
                <Route path ="/PeriodosAdmin" element={<ListadoPeriodosAdmin />} />
                <Route path ="/PeriodosAdminCreate" element={<PeriodosAdminCreate />} />
                <Route path ="/Ciclos" element={<ListadoCiclos />} />
                <Route path ="/Departamentos" element={<ListadoDepartamentos />} />
                <Route path ="/Proveedores" element={<ListadoProveedores />} />
                {/* Articulos */}
                <Route path ="/MenuArticulos" element={<BotonesArticulos />} />
                <Route path ="/Lineas" element={<ListadoLineas />} />
                <Route path ="/Colores" element={<ListadoColores />} />
                <Route path ="/Tallas" element={<ListadoTallas />} />
                <Route path ="/Marcas" element={<ListadoMarcas />} />
                <Route path ="/Familias" element={<ListadoFamilias />} />
                <Route path ="/Colecciones" element={<ListadoColecciones />} />
                <Route path ="/ListadoArticulos" element={<ListadoArticulos />} />
                <Route path ="/ListadoArticulosFoto" element={<ListadoArticulosFoto />} />
                <Route path ="/ArticulosCreate" element={<ArticulosCreate />} />
                <Route path ="/ArticulosBulkCreate" element={<ArticulosBulkCreate />} />
                <Route path="/GeneradorEtiquetas" element={<GeneradorEtiquetas />} />
                {/* Inventarios */}
                <Route path ="/MenuInventarios" element={<BotonesInventarios />} />
                <Route path ="/ListadoInventarios" element={<ListadoInventarios />} />
                <Route path ="/ListadoDisponible" element={<ListadoDisponible />} />
                <Route path ="/ListadoDisponibleVendedor" element={<ListadoDisponibleVendedor />} />
                <Route path ="/ListadoInventarioPendRecibir" element={<ListadoInventarioPendRecibir />} />
                <Route path ="/ListadoKardex" element={<ListadoKardex />} />
                <Route path ="/ListadoTracking" element={<ListadoTracking />} />
                <Route path ="/InventariosSeparados" element={<InventariosSeparados />} />
                <Route path ="/ListadoAjustesInventario" element={<ListadoAjustesInventario />} />
                <Route path ="/AjustesInventarioCreate" element={<AjustesInventarioCreate />} />
                <Route path ="/MenuTraspasos" element={<BotonesTraspasos />} />
                <Route path ="/CuadrarInventario" element={<CuadrarInventario />} />
                {/* Tiendas */}
                <Route path ="/MenuTiendas" element={<BotonesTiendas />} />
                <Route path ="/ListadoInventariosTiendas" element={<ListadoInventariosTiendas />} />
                <Route path ="/ListadoVentasTiendas" element={<ListadoVentasTiendas />} />
                <Route path ="/ListadoVentasTiendasPendientes" element={<ListadoVentasTiendasPendientes />} />
                <Route path ="/ListadoApartadosTiendas" element={<ListadoApartadosTiendas />} />
                <Route path ="/VentasTiendasCreate" element={<VentasTiendasCreate />} />
                <Route path ="/ApartadosTiendasCreate" element={<ApartadosTiendasCreate />} />
                <Route path ="/AbonosTiendasCreate" element={<AbonosTiendasCreate />} />
                <Route path ="/ListadoAbonosTiendas" element={<ListadoAbonosTiendas />} />
                <Route path ="/GastosTiendas" element={<ListadoGastosTiendas />} />
                <Route path ="/GastosTiendasCreate" element={<GastosTiendasCreate />} />
                <Route path ="/DinerosTiendas" element={<ListadoDinerosTiendas />} />
                <Route path ="/DinerosTiendasCreate" element={<DinerosTiendasCreate />} />
                <Route path ="/ListadoDevolucionesTiendas" element={<ListadoDevolucionesTiendas />} />
                <Route path ="/DevolucionesTiendasCreate" element={<DevolucionesTiendasCreate />} />
                <Route path ="/CorteTiendas" element={<CorteTiendas />} />
                <Route path ="/CorteTiendasK" element={<CorteTiendasK />} />
                <Route path ="/EntregarNota" element={<EntregarNota />} />
                <Route path ="/EstadoCuentaTiendas" element={<EstadoCuentaTiendas />} />
                <Route path ="/EstadoCuentaTiendasAnalisis" element={<EstadoCuentaTiendasAnalisis />} />
                <Route path ="/ListadoDevolucionesTiendasAdmin" element={<ListadoDevolucionesTiendasAdmin />} />
                <Route path ="/ListadoClientesTiendas" element={<ListadoClientesTiendas />} />
                <Route path ="/ClientesCreateTiendas" element={<ClientesCreateTiendas />} />
                <Route path ="/FacturasTiendasCreate/:idVenta" element={<FacturasTiendasCreate />} />
                <Route path ="/FacturasTiendasCreate" element={<FacturasTiendasCreate />} />
                <Route path ="/EscaneoTiendas" element={<Escaneos />} />
                <Route path ="/ListadoEscaneos" element={<ListadoEscaneos />} />

                {/* Traspasos */}
                <Route path ="/TraspasosSalidaCreate" element={<TraspasosSalidaCreate />} />
                <Route path ="/ListadoTraspasosSalida" element={<ListadoTraspasosSalida />} />
                <Route path ="/TraspasosEntradaCreate" element={<TraspasosEntradaCreate />} />
                <Route path ="/ListadoTraspasosEntrada" element={<ListadoTraspasosEntrada />} />
                {/* Compras */}
                <Route path ="/MenuCompras" element={<BotonesCompras />} />
                <Route path ="/ListadoOrdenesCompra" element={<ListadoOrdenesCompra />} />
                <Route path ="/OrdenesCompraCreate" element={<OrdenesCompraCreate />} />
                <Route path ="/ListadoEmbarques" element={<ListadoEmbarques />} />
                <Route path ="/EmbarquesCreate" element={<EmbarquesCreate />} />
                <Route path ="/ListadoPendEmbarcar" element={<ListadoPendEmbarcar />} />
                <Route path ="/ListadoCompras" element={<ListadoCompras />} />
                <Route path ="/ComprasCreate" element={<ComprasCreate />} />
                <Route path ="/ListadoPendRecibir" element={<ListadoPendRecibir />} />
                <Route path ="/ConceptosGastosEmbarques" element={<ListadoConceptosGastosEmbarques />} />
                <Route path ="/ListadoControlCalidad" element={<ListadoControlCalidad />} />
                {/* Ventas */}
                <Route path ="/MenuVentas" element={<BotonesVentas />} />
                <Route path ="/ListadoPedidos" element={<ListadoPedidos />} />
                <Route path ="/VistaPedido/:idPedido" element={<VistaPedido />} />
                <Route path ="/PedidosCreate" element={<PedidosCreate />} />
                <Route path ="/ListadoSurtidos" element={<ListadoSurtidos />} />
                <Route path ="/ListadoPendienteSurtir" element={<ListadoPendienteSurtir />} />
                <Route path ="/ListadoDevoluciones" element={<ListadoDevoluciones />} />
                <Route path ="/DevolucionesCreate" element={<DevolucionesCreate />} />
                <Route path ="/DepartamentosClientes" element={<ListadoDepartamentosClientes />} />
                <Route path ="/AnalisisArticulosPedidos" element={<AnalisisArticulosPedidos />} />
                <Route path ="/ListoSurtir" element={<ListoSurtir />} />
                <Route path ="/ListoSurtirCliente" element={<ListoSurtirCliente />} />
                <Route path ="/ReporteVentasPorVendedor" element={<ReporteVentasPorVendedor />} />
                {/* Gastos */}
                <Route path ="/MenuGastos" element={<BotonesGastos />} />
                <Route path ="/Presupuestos" element={<ListadoPresupuestos />} />
                <Route path ="/PresupuestosCreate" element={<PresupuestosCreate />} />
                <Route path ="/MenuNominas" element={<BotonesNominas />} />
                <Route path ="/Nominas" element={<ListadoNominas />} />
                <Route path ="/Empleados" element={<ListadoColaboradores />} />
                <Route path ="/EmpleadosCreate" element={<ColaboradoresCreate />} />
                <Route path ="/FaltasColaboradores" element={<ListadoFaltasColaboradores />} />
                <Route path ="/FaltasColaboradoresCreate" element={<FaltasColaboradoresCreate />} />
                <Route path ="/NominasCreate" element={<NominasCreate />} />
                <Route path ="/Puestos" element={<ListadoPuestos />} />
                <Route path ="/ProveedoresCreate" element={<ProveedoresCreate />} />
                <Route path ="/Gastos" element={<ListadoGastosGeneral />} />
                <Route path ="/GastosCreate" element={<GastosGeneralCreate />} />
                <Route path ="/ConceptosGastos" element={<ListadoConceptosGastos />} />
                <Route path ="/conceptosGastosCreate" element={<ConceptosGastosCreate />} />
                {/* Clientes */}
                <Route path ="/Clientes" element={<ListadoClientes />} />
                <Route path ="/ClientesCreate" element={<ClientesCreate />} />
                <Route path ="/Grupos" element={<ListadoGrupos />} />
                {/* Reportes */}
                <Route path ="/MenuReportes" element={<BotonesReportes />} />
                <Route path ="/MenuReportesV2" element={<BotonesReportesV2 />} />
                <Route path ="/MenuReportesAdmin" element={<BotonesReportesAdmin />} />
                <Route path ="/MenuReportesVentas" element={<BotonesReportesVentas />} />
                <Route path ="/GraficaVentasMensualComparativa" element={<GraficaVentasMensualComparativa />} />
                <Route path ="/TablaVentasArticulos" element={<TablaVentasArticulos />} />
                <Route path ="/TablaVentasMensualComparativa" element={<TablaVentasMensualComparativa />} />
                <Route path ="/TablaAbonosMensualComparativa" element={<TablaAbonosMensualComparativa />} />
                <Route path ="/TablaAbonosMensualComparativaAlmacen" element={<TablaAbonosMensualComparativaAlmacen />} />
                <Route path ="/TablaVentasMensualComparativaCliente" element={<TablaVentasMensualComparativaCliente />} />
                <Route path ="/TablaVentasMensualComparativaVendedor" element={<TablaVentasMensualComparativaVendedor />} />
                <Route path ="/GraficaVentasMensualCliente" element={<GraficaVentasMensualCliente />} />
                <Route path ="/GraficaVentasMensualVendedor" element={<GraficaVentasMensualVendedor />} />
                <Route path ="/GraficaVentasDesgloce" element={<GraficaVentasDesgloce />} />
                <Route path ="/GraficaVentasDepartamento" element={<GraficaVentasDepartamento />} />
                <Route path ="/GraficaVentasGrupo" element={<GraficaVentasGrupo />} />
                <Route path ="/GraficaVentasVendedor" element={<GraficaVentasVendedor />} />
                <Route path ="/GraficaVentasEstado" element={<GraficaVentasEstado />} />
                <Route path ="/ReporteUltimoPrecio" element={<ReporteUltimoPrecio />} />
                <Route path ="/ReporteUltimoPrecioArticulo" element={<ReporteUltimoPrecioArticulo />} />
                <Route path ="/ValorInventario" element={<ValorInventario />} />
                <Route path ="/SellThru" element={<ListadoSellThru />} />
                <Route path ="/CalificadoraClientes" element={<CalificadoraClientes />} />
                <Route path ="/ReporteResumenAbonosTiendas" element={<ReporteResumenAbonosTiendas />} />
                <Route path ="/ReporteResumenVentasTiendas" element={<ReporteResumenVentasTiendas />} />

                {/* Fiscal */}
                <Route path ="/MenuFiscal" element={<BotonesFiscal />} />
                <Route path ="/ListadoFacturas" element={<ListadoFacturas />} />
                <Route path ="/FacturasCreate" element={<FacturasCreate />} />
                <Route path ="/ListadoComplementosPago" element={<ListadoComplementosPago />} />
                <Route path ="/ComplementosPagoCreate" element={<ComplementosPagoCreate />} />
                <Route path ="/ListadoNotasCredito" element={<ListadoNotasCredito />} />
                <Route path ="/NotasCreditoCreate" element={<NotasCreditoCreate />} />
                <Route path ="/ListadoDevolucionesFiscal" element={<ListadoDevolucionesFiscal />} />
                <Route path ="/DevolucionesFiscalCreate" element={<DevolucionesFiscalCreate />} />
                <Route path ="/RegistrarEmpresas" element={<RegistrarEmpresas />} />
                <Route path ="/ListadoEmpresas" element={<ListadoEmpresas />} />
                <Route path ="/EmpresasCreate" element={<EmpresasCreate />} />

                {/* Dashboards */}
                <Route path ="/Dashboards" element={<BotonesDashboards />} />
                <Route path ="/DashboardVentas" element={<DashboardVentas />} />
                <Route path ="/DashboardInventarios" element={<DashboardInventarios />} />
                <Route path ="/Balance" element={<Balance />} />

                {/* Asistente IA */}
                <Route path ="/AsistenteIA" element={<AsistenteIAPage />} />
                {/* Logs  */}
                <Route path ="/MenuLogs" element={<Logs />} />
                {/* Monitoring  */}
                <Route path ="/Monitoring" element={<Monitoring />} />
                {/* Config  */}
                <Route path ="/MenuConfiguraciones" element={<Configuraciones />} />
                {/* Admin */}
                <Route path ="/MenuAdmin" element={<BotonesAdmin />} />
                <Route path ="/Bancos" element={<ListadoBancos />} />
                <Route path ="/AnticiposCreate" element={<AnticiposCreate />} />
                <Route path ="/ListadoAnticipos" element={<ListadoAnticipos />} />
                <Route path ="/AbonosCreate" element={<AbonosCreate />} />
                <Route path ="/ListadoAbonos" element={<ListadoAbonos />} />
                <Route path ="/NotasCargoCreate" element={<NotasCargoCreate />} />
                <Route path ="/ListadoNotasCargo" element={<ListadoNotasCargo />} />
                <Route path ="/ListadoDevolucionesAdmin" element={<ListadoDevolucionesAdmin />} />
                <Route path ="/EstadoCuenta" element={<EstadoCuenta />} />
                <Route path ="/ComisionesCreate" element={<ComisionesCreate />} />
                <Route path ="/ListadoComisiones" element={<ListadoComisiones />} />
                <Route path ="/ListadoVentas" element={<ListadoVentas />} />
                <Route path ="/EstadoCuentaVendedores" element={<EstadoCuentaColaboradores />} />
                {/* CXP */}
                <Route path ="/MenuCXP" element={<BotonesCXP />} />
                <Route path ="/EstadoCuentaCXP" element={<EstadoCuentaCXP />} />
                <Route path ="/ListadoComprasCXP" element={<ListadoComprasCXP />} />
                <Route path ="/AbonosProveedoresCreate" element={<AbonosProveedoresCreate />} />
                <Route path ="/ListadoAbonosProveedores" element={<ListadoAbonosProveedores />} />
                {/* Traspasos Dinero */}
                <Route path ="/TraspasosDineroCreate" element={<TraspasosDineroCreate />} />
                <Route path ="/ListadoTraspasosDinero" element={<ListadoTraspasosDinero />} />
                  {/* Cadenas */}
                  <Route path ="/MenuCadenas" element={<BotonesCadenas />} />
                <Route path ="/ListadoInsumos" element={<ListadoInsumos />} />
                <Route path ="/InsumosCreate" element={<InsumosCreate />} />
                <Route path ="/ProveedoresMex" element={<ListadoProveedoresMex />} />
                <Route path ="/ProveedoresCreateMex" element={<ProveedoresCreateMex />} />
                <Route path ="/ListadoOrdenesCompraHab" element={<ListadoOrdenesCompraHab />} />
                <Route path ="/OrdenesCompraHabCreate" element={<OrdenesCompraHabCreate />} />
                <Route path ="/ListadoComprasHab" element={<ListadoComprasHab />} />
                <Route path ="/ComprasHabCreate" element={<ComprasHabCreate />} />
                <Route path ="/ListadoInventariosInsumos" element={<ListadoInventariosInsumos />} />
                <Route path ="/ListadoCadenas" element={<ListadoCadenas />} />
                <Route path ="/ListadoPedidosCadenas" element={<ListadoPedidosCadenas />} />
                <Route path ="/EstadoCuentaHab" element={<EstadoCuentaHab />} />
                <Route path ="/AbonosProveedoresHabCreate" element={<AbonosProveedoresHabCreate />} />
                <Route path ="/ListadoAbonosProveedoresHab" element={<ListadoAbonosProveedoresHab />} />
                {/* Whatsapp */}
                <Route path ="/Whatsapp" element={<Whatsapp />} />
                <Route path ="/ClientesWhatsapp" element={<ListadoClientesWhatsapp />} />
                <Route path ="/ListadoPedidosWhatsapp" element={<ListadoPedidosWhatsapp />} />
            </Routes>

            <ChatWidget />
            </BrowserRouter>
            </ChatContextProvider>
            </AuthContextProvider>

    )
}

export default RoutesComponent
